import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import './index.scss';
function LandmarkCard(props) {
    const { landmark, onOpenLandmark } = props;
    return <Button className="pj-landmark" onPress={() => onOpenLandmark(landmark)}>
      <Image className="pj-landmark__bg" source={{
        uri: landmark.icon
    }} resizeMode="cover"/>
      <View x-if={!landmark.obtained} className="pj-landmark__mask"/>
      <View className="pj-landmark__band">
        <Text className="pj-landmark__name" numberOfLines={1} style={!landmark.obtained ? {
        color: 'rgba(255, 255, 255, 0.8)'
    } : {}}>
          {landmark.name}
        </Text>
      </View>
    </Button>;
}
export default memo(LandmarkCard);
